import React, { useEffect, useRef, useState } from 'react';

import { useLocation } from '@reach/router';

import { MOBILE_OPEN, SIDEBAR_LANGUAGE } from '../../utils/constants';
import { IconArrowLeft, IconSemiArrowLeft, getIcon } from '../Icons';

import LanguageLocalization from '../LanguageLocalization/LanguageLocalization';
import { TooltipTrigger } from '../TooltipTrigger/TooltipTrigger';
import './SideBar.scss';
import useWindowSize from '../../hooks/useWindowSize';

interface NavLink {
  id: number;
  name: string;
  url: string;
  icon: string;
}

interface PrevPageProps {
  title: string;
  pathname: string;
}

export interface SideBarProps {
  links: NavLink[];
  prevPage?: PrevPageProps;
  selectedItem?: string;
  actualPage?: string;
  leafPage?: string;
  nestedCategories?: any[];
}

export default function ProgrammingSideBar(props: SideBarProps): React.ReactElement {
  const { links, prevPage, actualPage } = props;
  const location = useLocation();
  //const isDesktop = typeof window !== 'undefined' ? window.innerWidth > 768 : true;
  //const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 580 : false;
  const { isMobile, isTablet } = useWindowSize();

  const isDesktop = useRef(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      isDesktop.current = window.innerWidth > 768;
    }
  });

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  function toggleSidebar() {
    if (document.querySelector('.sidebar') && document.querySelector('.sidebar__control--icon') && document.querySelector('.sidebar__first-level')) {
      document.querySelector('.sidebar').classList.toggle('closed');
      document.querySelector('.sidebar__control--icon').classList.toggle('closed');
      document.querySelector('.sidebar__first-level').classList.toggle('hideOverflow');
    }
  }

  useEffect(() => {
    if (isMobile || isTablet) {
      const checkUserData = () => {
        const item = localStorage.getItem(MOBILE_OPEN);

        if (item) {
          setIsMobileOpen(item === 'opened' ? true : false);
        }
      };

      const element = window;

      element.addEventListener('click', checkUserData);

      return () => {
        element.removeEventListener('click', checkUserData);
      };
    }
  }, [isMobile, isTablet]);

  useEffect(() => {
    const item = localStorage.getItem(MOBILE_OPEN);
    if (document.querySelector('.sidebar') && isMobile) {
      if (item === 'opened') {
        (document.querySelector('.sidebar') as HTMLElement).style.display = 'unset';
      } else {
        (document.querySelector('.sidebar') as HTMLElement).style.display = 'none';
      }
    }
  }, [isMobile, isMobileOpen]);

  return (
    <>
      {isDesktop.current ? (
        <>
          <div className="sidebar">
            {location.pathname !== '/' && (
              <div className="sidebar__breadcrumbs">
                <a href={prevPage ? prevPage.pathname : '/'}>
                  <IconArrowLeft />
                  <span className="sidebar__breadcrumbs--space">{prevPage ? prevPage.title : 'All Docs'}</span>
                </a>
                <div className="sidebar__box">
                  {actualPage && <div className="sidebar__breadcrumbs--title">{actualPage}</div>}
                  {actualPage === SIDEBAR_LANGUAGE && <LanguageLocalization />}
                </div>
                <TooltipTrigger
                  TriggerElement={
                    <button className="sidebar__control" onClick={() => toggleSidebar()}>
                      <IconSemiArrowLeft className="sidebar__control--icon" />
                    </button>
                  }
                  delay={0}
                  tooltipPlacement="right"
                  tooltipStrategy="absolute"
                  tooltipType="tooltip"
                  onClick={() => toggleSidebar()}
                >
                  Collapse
                </TooltipTrigger>
              </div>
            )}
            <div className="sidebar__first-level">
              <div className="sidebar__navigation">
                {links.map((el) => {
                  return (
                    <a href={el.url} className="sidebar__programming" key={el.id}>
                      <span>{el.name}</span>
                      {getIcon('IconArrowRightJet')}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {isMobileOpen && (isMobile || isTablet) ? (
            <div className="sidebar-mobile">
              {location.pathname !== '/' && (
                <div className="sidebar-mobile__breadcrumbs">
                  <a href={prevPage ? prevPage.pathname : '/'}>
                    <IconArrowLeft />
                    <span className="sidebar-mobile__breadcrumbs--space">{prevPage ? prevPage.title : 'All Docs'}</span>
                  </a>
                  {actualPage && <div className="sidebar-mobile__breadcrumbs--title">{actualPage}</div>}
                </div>
              )}
              <div className="sidebar-mobile__first-level">
                <div className="sidebar-mobile__navigation">
                  {links.map((el) => {
                    return (
                      <a href={el.url} className="sidebar-mobile__programming" key={el.id}>
                        <span>{el.name}</span>
                        {getIcon('IconArrowRightJet')}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </>
  );
}
